import { render, staticRenderFns } from "./messageBubble.vue?vue&type=template&id=44fdfc20&scoped=true"
import script from "./messageBubble.vue?vue&type=script&lang=js"
export * from "./messageBubble.vue?vue&type=script&lang=js"
import style0 from "./messageBubble.vue?vue&type=style&index=0&id=44fdfc20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fdfc20",
  null
  
)

export default component.exports